const BASE_URL = '/api/collections/advisors/entries';

export default () => ({
  advisors: [],
  filter: '',

  sortAdvisors() {
    this.advisors = this.advisors.sort((a, b) => {
      if (this.filter == 'alphabetical') {
        return a.title.localeCompare(b.title.localeCompare);
      } else if (this.filter == 'gdpr') {
        return b.gdpr_audit.value - a.gdpr_audit.value;
      } else if (this.filter == 'training') {
        return b.training.value - a.training.value;
      } else if (this.filter == 'advisory') {
        return b.advisory.value - a.advisory.value;
      }
    });
  },

  parseWebsite(string) {
    return string.replace('https://', '');
  },

  getAdvisors() {
    fetch(`${BASE_URL}?sort=title`)
      .then((response) => response.json())
      .then((response) => {
        this.advisors = response.data;
      });
  },

  init() {
    this.getAdvisors();
  },
});
